import { render, staticRenderFns } from "./rolemanagementtable.vue?vue&type=template&id=5bbf13f5&scoped=true&"
import script from "./rolemanagementtable.vue?vue&type=script&lang=js&"
export * from "./rolemanagementtable.vue?vue&type=script&lang=js&"
import style0 from "./rolemanagementtable.vue?vue&type=style&index=0&id=5bbf13f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf13f5",
  null
  
)

export default component.exports